// place component scope helper functions here

export enum Tabs {
  LOGIN = 'Log in',
  REGISTER = 'Register'
}
